export default "__VITE_ASSET__587f0e87__"